import { useState, useEffect, useCallback, useMemo } from 'react';
import { apiFetch } from './api.js';

export function useSystemNotifications() {
  const [notifications, setNotifications] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const controller = new AbortController();
    apiFetch('/me/notifications', { signal: controller.signal })
      .then(data => setNotifications(data.data ?? []))
      .catch(() => {})
      .finally(() => { if (!controller.signal.aborted) setLoading(false); });
    return () => controller.abort();
  }, []);

  const unreadCount = useMemo(() => notifications.filter(n => !n.read).length, [notifications]);

  const markRead = useCallback((id) => {
    setNotifications(prev => prev.map(n => (n.id === id ? { ...n, read: true } : n)));
    apiFetch(`/me/notifications/${id}`, { method: 'PATCH' }).catch(() => {});
  }, []);

  return { notifications, unreadCount, loading, markRead };
}
